import React from 'react';
import { motion } from 'framer-motion';

const Plagiarism = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="max-w-4xl mx-auto px-4 py-12"
    >
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent mb-6">
          Plagio
        </h1>
        <p className="text-xl text-gray-600 dark:text-gray-300">
          Aprende sobre el plagio y sus implicaciones
        </p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-4 md:p-8">
        <div className="flex justify-center mb-8">
          <div className="w-full max-w-sm">
            <div className="relative pb-[177.78%] h-0 overflow-hidden rounded-lg shadow-lg">
              <iframe 
                src="https://embed.wave.video/GuOZQL9244EK7WQP" 
                className="absolute top-0 left-0 w-full h-full"
                frameBorder="0" 
                allow="autoplay; fullscreen" 
                scrolling="no"
                style={{ aspectRatio: '9/16' }}
              />
            </div>
          </div>
        </div>
        
        <div className="text-center">
          <p className="text-gray-600 dark:text-gray-400 text-sm">
            Fuente:{' '}
            <a 
              href="https://www.tiktok.com/@alfredmenendez/video/7205326471349472517"
              target="_blank"
              rel="noopener noreferrer"
              className="text-indigo-600 dark:text-indigo-400 hover:underline"
            >
              Menéndez (2023a).
            </a>
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default Plagiarism;